export const DEFAULT_IMAGE =
  '//stockx-assets.imgix.net/media/Product-Placeholder-Default-20210415';
export const PLACEHOLDER_IMAGE_URL = `https:${DEFAULT_IMAGE}.jpg?fit=fill&bg=FFFFFF&auto=format,compress&q=90&dpr=2&trim=color`;
export const VALID_SRC_DOMAINS = ['.net/', '.io/', '.com/'];

/* Mappings for Imgix quality based on dpr value */
export const BASE_VARIABLE_QUALITIES = {
  1: 57,
  2: 60,
  3: 41,
  4: 35,
  5: 30,
};

export const CATALOG_IMAGE_BASE_WIDTH = 576;
export const CATALOG_IMAGE_BASE_HEIGHT = (CATALOG_IMAGE_BASE_WIDTH / 3) * 2;
